import React from "react";
import { Box, Paper, Grid } from "@material-ui/core";
import { ICompanyProfileItem } from "src/common/typings/companyProfile";
import CommonButtonDefault from "src/components/CommonButton/CommonButtonDefault";
import { CardItem } from "./CardItem";

interface Props {
  InfoData: ICompanyProfileItem | any;
  editCompany: () => void;
}

export const Card = ({ InfoData, editCompany }: Props) => {
  const {
    company,
    address,
    contactEmail,
    contactPerson,
    fax,
    mailingAddress,
    mailingCompany,
    phone,
    city,
    zip,
    state,
    mailingCity,
    mailingState,
    mailingZip,
  } = InfoData;
  const renderCombineValie = (per: boolean) => {
    const combineAddress: any[] = [];
    if (per) {
      if (address) {
        combineAddress.push(address);
      }
      if (city) {
        if (address) {
          combineAddress.push(` ${city}`);
        } else {
          combineAddress.push(city);
        }
      }
      if (state) {
        if (address || city) {
          combineAddress.push(` ${state}`);
        } else {
          combineAddress.push(state);
        }
      }
      if (zip) {
        if (address || city || state) {
          combineAddress.push(` ${zip}`);
        } else {
          combineAddress.push(zip);
        }
      }
    } else {
      if (mailingAddress) {
        combineAddress.push(mailingAddress);
      }
      if (mailingCity) {
        if (mailingAddress) {
          combineAddress.push(` ${mailingCity}`);
        } else {
          combineAddress.push(mailingCity);
        }
      }
      if (mailingState) {
        if (mailingAddress || mailingCity) {
          combineAddress.push(` ${mailingState}`);
        } else {
          combineAddress.push(mailingState);
        }
      }
      if (mailingZip) {
        if (mailingAddress || mailingCity || mailingState) {
          combineAddress.push(` ${mailingZip}`);
        } else {
          combineAddress.push(mailingZip);
        }
      }
    }
    if (combineAddress.length) {
      return combineAddress.toString();
    } else {
      return "";
    }
  };
  return (
    <>
      <Paper elevation={1} square>
        <Box p={2} mb={3}>
          <Grid container direction="row">
            <Grid container direction="row" xs={10} md={10}>
              <CardItem field="Company" value={company} />
              <CardItem field="Contact Email" value={contactEmail} />
              <CardItem field="Contact Person" value={contactPerson} />
              <CardItem field="Fax" value={fax} />
              <CardItem field="Phone #" value={phone} />
              <CardItem field="Check Company" value={mailingCompany} />
              <CardItem field="Address" value={renderCombineValie(true)} fullwidth />
              <CardItem field="Check Address" value={renderCombineValie(false)} fullwidth />
            </Grid>
            <Grid item xs={12} md={2}>
              <Box mb={2} textAlign="right" display="flex" flexDirection="column">
                <Box component="span">
                  <>
                    <CommonButtonDefault isGreen onClick={() => editCompany()}>
                      Edit
                    </CommonButtonDefault>
                  </>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </>
  );
};
